var assign = require('@antv/util/lib/mix');

module.exports = {
  assign: assign
};


//////////////////
// WEBPACK FOOTER
// ./src/util.js
// module id = 0
// module chunks = 0